import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import { initAnalytics, initErrorReporting, track } from "@/lib/analytics";
const Valuate = lazy(() => import("@/pages/Valuate"));
const Results = lazy(() => import("@/pages/Results"));
const About = lazy(() => import("@/pages/About"));
const Terms = lazy(() => import("@/pages/Terms"));
const Contact = lazy(() => import("@/pages/Contact"));
const History = lazy(() => import("@/pages/History"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Disclaimer = lazy(() => import("@/pages/Disclaimer"));
const HowWeCalculate = lazy(() => import("@/pages/HowWeCalculate"));
const MyOffers = lazy(() => import("@/pages/MyOffers"));
const ForDealers = lazy(() => import("@/pages/ForDealers"));
const DealerApply = lazy(() => import("@/pages/DealerApply"));
const DealerLogin = lazy(() => import("@/pages/DealerLogin"));
const DealerDashboard = lazy(() => import("@/pages/DealerDashboard"));
const AdminApp = lazy(() => import("@/pages/admin/AdminApp"));
const SeoFallback = lazy(() => import("@/pages/SeoFallback"));

initAnalytics();
initErrorReporting();

function AppRouter() {
  const location = useLocation();
  React.useEffect(() => { track("visit", { path: location.pathname }); }, [location.pathname]);
  // Process OAuth redirect synchronously before normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Suspense fallback={<div style={{ minHeight: "60vh" }} aria-busy="true" />}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/valuate" element={<Valuate />} />
      <Route path="/results" element={<Results />} />
      <Route path="/about" element={<About />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/history" element={<History />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/how-we-calculate" element={<HowWeCalculate />} />
      <Route path="/my-offers" element={<MyOffers />} />
      <Route path="/dealers" element={<ForDealers />} />
      <Route path="/for-dealers" element={<ForDealers />} />
      <Route path="/dealer/apply" element={<DealerApply />} />
      <Route path="/dealer/login" element={<DealerLogin />} />
      <Route path="/dealer/reset" element={<DealerLogin />} />
      <Route path="/dealer" element={<DealerDashboard />} />
      <Route path="/admin" element={<AdminApp />} />
      <Route path="/resale-price/*" element={<SeoFallback />} />
      <Route path="/guides/*" element={<SeoFallback />} />
      <Route path="/hi/*" element={<SeoFallback />} />
      <Route path="*" element={<Home />} />
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
